<template>
<div>
  <el-row style="margin-bottom: 10px;" type="flex" align="middle">
    <el-select v-model="selectedCustomimageTypeId" placeholder="Select" :class="$style.combobox" @change="onCustomimageTypeChange">
      <el-option v-for="item in customimageTypeList" :key="item.customimagetypeId" :label="item.customimagetypeName" :value="item.customimagetypeId">
      </el-option>
    </el-select>
    <el-button type="content" size="mini" @click="onImageSettingClick"><i class="fa fa-plus"></i> 이미지 설정</el-button>
  </el-row>
  <el-row style="height: calc(100% - 38px);">
    <el-table ref="imageTable" :data="customimageList" height="100%" :class="[$style.table, 'popup']" highlight-current-row @current-change="onSelectedImageChange" v-loading="isLoading">
      <el-table-column label="이미지명">
        <template slot-scope="scope">
            <drag :transfer-data="transferData(scope.row)">
              <div :class="$style.row">
                <span>{{ scope.row.customimageName }}</span>
              </div>
              <div class="drag-label" slot="image">{{ scope.row.customimageName }}</div>
            </drag>
          </template>
      </el-table-column>
      <el-table-column label="이미지" width="120">
        <template slot-scope="scope">
            <drag :transfer-data="transferData(scope.row)">
              <div :class="$style.row">
                <img :src="`data:${scope.row.customimageMimetype};base64,${scope.row.customimageBlob}`" :class="$style.img"/>
              </div>
              <div class="drag-label" slot="image">{{ scope.row.customimageName }}</div>
            </drag>
          </template>
      </el-table-column>
    </el-table>
  </el-row>
</div>
</template>


<script>
import { Drag } from 'vue-drag-drop';

import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import { Q, MapInfo } from '@/views/topologymap/js/maps';

export default {
  name: 'WCustomImageElement',
  components: {
    Drag,
  },
  data() {
    return {
      isLoading: false,
      customimageTypeList: [],
      customimageList: [],
      selectedCustomimageTypeId: '',
      selectedImage: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    /**
     * 데이터 로드
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    loadData() {
      this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.IMAGE_LOAD, this.loadData);

      MapAPI.getCustomimage().then((response) => {
        const result = response.data;

        if (result.success) {
          this.$store.commit('setCustomimage', result.data);
        }
        this.loadCustomimageType();
      });
    },
    /**
     * 이미지 설정 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onImageSettingClick() {
      // 이미지 로드 이벤트 리스너
      this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.IMAGE_LOAD, this.loadData);

      MapInfo.getInstance(this).getPanel().$refs.imageSettingPopup.open();
    },
    /**
     * 이미지 그룹 로드
     * @author KangBonghun(toto1323)
     */
    loadCustomimageType() {
      MapAPI.getCustomimageTypeList().then((response) => {
        const result = response.data;

        if (result.success) {
          this.customimageTypeList = result.data;
          this.selectedCustomimageTypeId = response.data.data[0].customimagetypeId;

          this.loadCustomimage(this.selectedCustomimageTypeId);
        }
      });
    },
    /**
     * 이미지 로드
     * @author KangBonghun(toto1323)
     * @param  {Number} customimageTypeId 이미지 그룹 아이디
     */
    loadCustomimage(customimageTypeId) {
      this.isLoading = true;
      this.selectedImage = null;
      MapAPI.getCustomimageList(customimageTypeId).then((response) => {
        const result = response.data;

        if (result.success) {
          this.customimageList = result.data;
        }
        this.isLoading = false;
      });
    },
    /**
     * 이미지 그룹 선택 변경
     * @author KangBonghun(toto1323)
     * @param  {Number} customimageTypeId 변경 된 이미지 그룹 아이디
     */
    onCustomimageTypeChange(customimageTypeId) {
      this.loadCustomimage(customimageTypeId);
    },
    /**
     * 선택 된 이미지 반환
     * @author KangBonghun(toto1323)
     * @return {Object} 선택 된 이미지 데이터
     */
    getSelectedImage() {
      return this.selectedImage;
    },
    /**
     * 이미지 선택 변경
     * @author KangBonghun(toto1323)
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    onSelectedImageChange(val) {
      this.selectedImage = val;
    },
    transferData(rowData) {
      return {
        type: Q.ImageModel,
        data: [rowData],
      };
    },
  },
};
</script>

<style module>
.table {
  width: 100%;
}

.row {
  height: 100px;
  line-height: 100px;
  width: 100%;
  vertical-align: middle;
}

.img {
  height: 100%;
  width: 100%;
}

.combobox {
  width: 100%;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/element/CustomImageElement.vue